import qs from 'qs';

const queryHelper = {};
const queryState = {};
let hasParsedInitialQuery = false;

function parseInitialQuery() {
  if (typeof window === 'undefined') {
    return;
  }

  const parsedPreexistingQuery = qs.parse(window.location.search.split('?').pop());

  Object.keys(parsedPreexistingQuery).forEach((key) => {
    queryState[key] = parsedPreexistingQuery[key];
  });

  hasParsedInitialQuery = true;
}

queryHelper.updateQueryWithValues = (kvp) => {
  if (!hasParsedInitialQuery) {
    parseInitialQuery();
  }

  Object.keys(kvp).forEach((key) => {
    if (kvp[key] != null && kvp[key].length > 0) {
      queryState[key] = kvp[key];
    } else {
      delete queryState[key];
    }
  });

  // TODO: modernizr check?
  if (typeof history !== 'undefined' && history.replaceState) {
    const shouldHaveQs = Object.keys(queryState).length > 0;
    const query = shouldHaveQs ? `?${qs.stringify(queryState)}` : '';
    history.replaceState(null, null, `${window.location.pathname}${query}${window.location.hash}`);
  }
};

queryHelper.getQueryKeyValue = (key) => {
  if (!hasParsedInitialQuery) {
    parseInitialQuery();
  }
  return queryState[key] || '';
};

queryHelper.getQueryKeyValues = (keys = []) => {
  return keys.map(queryHelper.getQueryKeyValue);
};

export default queryHelper;
